import React, { useState } from 'react';
import Logo from "../../../components/common/Brand";
import { useDispatch, useSelector } from 'react-redux';
import { requestPasswordResetLink } from '../../../redux/slices/authSlice';

import { Link } from 'react-router-dom';
import { Container, FormContainer, ImgSection } from './ForgotPasswordStyles';

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);

  const [email, setEmail] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(requestPasswordResetLink(email));
  };

  return (
    <Container>
      <FormContainer>
      <Link to="/">
        <Logo size={32} />
      </Link>
        <div className='header'>
          <h1>Forgot Password?</h1>
          <p>Enter your email and we will send you reset instructions</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className='single-form'>
            <label htmlFor='email'>Email</label>
            <input
              type='email'
              placeholder='Email'
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? 'Sending...' : 'Reset Password'}
          </button>
        </form>
      </FormContainer>

      <ImgSection>
        <div>
          <Logo size={26} />
          <p>
            Run your ads and campaigns with DigiClick and make huge <br />
            impressions and conversions that will help your business
          </p>
        </div>
      </ImgSection>
    </Container>
  );
};

export default ForgotPassword;
